<template>
    <div class="container">
        <v-title :breadcrumb="{label: 'Settings', route: {name: 'settings'}, root: true}">
            Settings
        </v-title>
        <div class="grid">
            <div class="grid-item">
                <div class="tile">
                    <div class="tile-content">
                        <div class="grid-fitted">
                            <div class="grid-item grid-item-third"
                                 v-coming-soon="item.comingSoon"
                                 v-for="item in settingsItems">
                                <router-link class="settings-item" :to="item.route">
                                    <div class="avatar avatar-description">
                                        <div class="avatar-image">
                                            <div class="avatar-icon">
                                                <v-icon :icon="item.icon"></v-icon>
                                            </div>
                                        </div>
                                        <div class="avatar-info text-left">
                                            <p :class="{'text-muted': item.comingSoon}">{{item.label}}</p>
                                            <p class="text-muted">{{item.description}}</p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {
        vIcon, vIconSprites,
    } from '@/components/form';
    import settingMenuItems from '@/modules/settings/settings-menu';

    export default {
        components: {
            vTitle, vIconSprites, vIcon,
        },

        data() {
            return {};
        },
        computed: {
            settingsItems() {
                return settingMenuItems
                    .filter(({route}) => {
                        if (!route.name) {
                            return true;
                        }
                        return route && route.name && this.$auth.$pages[route.name].isAllowed;
                    }).sort(({label}, {label: labelB}) => (label > labelB ? 1 : -1));
            },
        },
        directives: {
            comingSoon: {
                bind: (el, {value}) => {
                    if (value) {
                        el.classList.add('has-tooltip');
                        el.setAttribute('data-tooltip', 'Coming Soon');
                    }
                },
            },
        },
    };
</script>

<docs>
    ```jsx
    <settings/>
    ```
</docs>
